import React from "react"

const Loading = () => (
  <div className="loading">
    <div className="loading__icon" />
  </div>
)

export default Loading
